<template>
  <!-- bph: broadcast-planning-history -->
  <base-container :fluid="true" class="bph">
    <base-container>
      <the-header>
        <template v-slot:leftAligned>
          <the-breadcrumb :to="{ name: 'planning' }"
            >RETOUR AU CATALOGUE DE VIDÉOS</the-breadcrumb
          >
          <h1 class="lvl1-heading">
            Historique
            <span>de diffusion</span>
          </h1>
          <span>
            Une ancienne campagne de communication avait bien fonctionné ?
            Retrouvez toutes vos listes de diffusion des années précédentes.
          </span>
        </template>
        <template v-slot:rightAligned>
          <el-select v-model="currentYear" placeholder="Select">
            <el-option
              v-for="year in years"
              :key="year"
              :label="year"
              :value="year"
            ></el-option>
          </el-select>
        </template>
      </the-header>
    </base-container>
    <base-container ref="planningsContainer">
      <template v-if="plannings">
        <HistorySingleMonthPlanning :planning="plannings[0]" />
      </template>
    </base-container>
  </base-container>
</template>

<script>
import TheHeader from "@/components/TheHeader"
import HistorySingleMonthPlanning from "./components/HistorySingleMonthPlanning"
import TheBreadcrumb from "@/components/TheBreadcrumb"
import { Select, Option } from "element-ui"
import { fetchPlanningsHistory } from "@/api/plannings"
import { loaderMixin, planningMixin } from "@/mixins"

const START_YEAR = "2019"

export default {
  components: {
    TheHeader,
    HistorySingleMonthPlanning,
    TheBreadcrumb,
    ElSelect: Select,
    ElOption: Option
  },
  mixins: [loaderMixin, planningMixin],
  data() {
    return {
      year: new Date().getFullYear(),
      currentYear: null,
      plannings: null
    }
  },
  computed: {
    years() {
      if (!this.currentYear) return
      const arr = []
      let year = this.year
      while (year >= START_YEAR) {
        arr.push(year)
        year--
        year = year.toString()
      }
      return arr
    }
  },
  watch: {
    currentYear: "getHistoryPlanning"
  },
  methods: {
    getHistoryPlanning() {
      this.openLoader(this.$refs.planningsContainer.$el)

      fetchPlanningsHistory(this.currentYear)
        .then(this.structurePlanningsData)
        .then(plannings => {
          this.plannings = plannings
          this.closeLoader()
        })
        .catch(err => {
          console.error(err)
          this.closeLoader()
        })
    }
  },
  mounted() {
    this.currentYear = this.year
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
@import "@/styles/variables.scss";
$input-height: 50px;
.bph {
  .lvl1-heading {
    margin-top: 25px;
    margin-bottom: 25px;
  }

  .el-select {
    width: 179px;
    align-self: flex-end;
    margin-top: auto;

    .el-input {
      display: inline-block;
      height: $input-height;
      input {
        background: transparent;
        height: $input-height;
        border: 1px solid;
        -webkit-appearance: none;
        padding: 16px 16px 16px 20px;
        border-radius: 0 !important;
        color: $color-primary;
        color: var(--color-primary, $color-primary);
        border-color: $color-neutral-3 !important;
        border-color: var(--color-neutral-3, $color-neutral-3) !important;
        font-size: 15px;

        &:focus {
          border-color: $color-secondary !important;
          border-color: var(--color-secondary, $color-secondary) !important;
        }
      }

      .el-select__caret {
        color: $color-secondary !important;
        color: var(--color-secondary, $color-secondary) !important;
      }
    }
  }
}

.el-select-dropdown {
  border-radius: 0 !important;
}

.el-loading-parent--relative {
  margin-top: 80px;
}
</style>
